var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',{attrs:{"multiple":"","name":_vm.name,"options":_vm.options,"noResultsText":"Nichts gefunden","placeholder":"","clearable":false,"value-consists-of":_vm.leafPriority ? 'LEAF_PRIORITY' : undefined},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }